import type { FaireProductEntity } from "../../entity_types/product";

export const p_45ksdjtpvs: FaireProductEntity = {
  token: "p_45ksdjtpvs",
  type: "product",
  name: "Retail Starter Bundle",
  brandToken: "b_vhk6a6ndm2",
  brandName: "Dip",
  imageUrl:
    "https://cdn.faire.com/fastly/6c93957475bc7f33a0c894ed15627fb94b601a20098ec92d391de114fd982f6f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ef69242940403a64fa8759f89a53d7be47313b2e8c2c2dcd4eb99da34c1db2c.jpeg",
  ],
  priceDollars: 647.95,
  description:
    "Our Retail Starter Bundle makes it easy to get started with Dip. This set includes Shampoo and Conditioner Bars in both sizes for three of our best-selling scents + fragrance-free, plus our Hair & Body Dry Oils. Perfect for testing sales velocity while getting started, this bundle helps set you up for success while selling Dip. Stocking both sizes (even in fewer scents) outperforms minis alone every time. Our full size bars are a better value, and customers notice the difference when they shop.\n\nBundle includes:\n\nCoconut + Almond\n(4) Mini Shampoos\n(4) Mini Conditioners\n(4) Full Shampoos\n(4) Full Conditioners\n(2) Dry Oils\n\nRosewater + Jasmine & Tobacco + Driftwood\n(3) Mini Shampoos\n(3) Mini Conditioners\n(3) Full Shampoos\n(3) Full Conditioners\n(2) Dry Oils\n\nFragrance Free\n(3) Mini Shampoos\n(3) Mini Conditioners\n(3) Full Shampoos\n(3) Full Conditioners\n",
  tags: [],
  msrpDollars: 1295.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:07.961Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
